import { useMemo as n } from "react";
import { getRelativeDateByLabel as l } from "./index.es2483.js";
const a = (t, e, r) => t.reduce((o, s) => (o[s] = {
  label: s,
  value: l(s, e, r)
}, o), {}), u = (t = /* @__PURE__ */ new Date(), e) => a(
  ["Month to Date", "Quarter to Date", "Year to Date"],
  t,
  e
), P = (t = /* @__PURE__ */ new Date(), e) => a(
  [
    "Last full 4 weeks",
    "Last full 6 weeks",
    "Last full 3 months",
    "Last full 6 months",
    "Last full 12 months"
  ],
  t,
  e
), d = (t = /* @__PURE__ */ new Date(), e) => a(
  [
    "Past 7 days",
    "Past 30 days",
    "Past 60 days",
    "Past 90 days",
    "Past 6 months",
    "Past 12 months"
  ],
  t,
  e
), i = (t, e) => n(() => ({
  toMaxDate: u(t, e),
  fullPeriod: P(t, e),
  passPeriod: d(t, e)
}), [t, e]);
export {
  i as useRelativePreset
};
//# sourceMappingURL=index.es5824.js.map
